module.exports = {
  fi: 'Helsingin yliopiston ja Houston Inc:n kaikille avoin ja ilmainen moderniin JavaScript-pohjaiseen web-sovelluskehitykseen keskittyvä kurssi. Osallistujilta edellytetään vahvaa ohjelmointirutiinia, pitkäjänteistyyttä ja valmiuksia omatoimiseen ongelmanratkaisuun.',
  en: 'Open online course on JavaScript based modern web development by University of Helsinki and Houston Inc..',
  es: 'Curso en línea abierto de desarrollo web moderno basado en JavaScript por la Universidad de Helsinki y Houston Inc..',
};
